import classNames from 'classnames';

import { Alert, Icon } from '../Icon';

import info from '../../assets/info-v2.svg';
import { ReactComponent as WarningIcon } from '../../assets/warning.svg';
import styles from './index.module.css';

type Variant = 'info' | 'error' | 'warning';

interface Props {
  children?: React.ReactNode;
  variant?: Variant;
  isError?: boolean;
  hideIcon?: boolean;
  className?: string;
}

function getIcon(variant: Variant) {
  switch (variant) {
    case 'info':
      return (
        <img className={styles.InformationIcon} alt="information" src={info} />
      );
    case 'warning':
      return <WarningIcon />;
    case 'error':
      return (
        <Icon
          className={styles.AlertIcon}
          icon={Alert}
          title="alert-icon"
          size={1}
        />
      );
  }
}

export function InfoMessage(props: Props) {
  const { children, isError, hideIcon, className, variant = 'info' } = props;
  if (!children) return <></>;
  const _variant = isError ? 'error' : variant;
  return (
    <div
      className={classNames(styles.InfoMessage, className, {
        [styles.ErrorColor]: _variant === 'error',
        [styles.InfoColor]: _variant === 'info',
        [styles.WarningColor]: _variant === 'warning',
      })}
    >
      <div className={styles.IconContainer}>
        {!hideIcon && getIcon(_variant)}
      </div>
      <div className={styles.TextContainer}>{children}</div>
    </div>
  );
}
